import React from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(/* error */) {
		// Update state so the next render will show the fallback UI.
		// console.log('getDerivedStateFromError', error)
		return { hasError: true };
	}

	componentDidCatch(/* error, errorInfo */) {
		// You can also log the error to an error reporting service
		// console.log(error, errorInfo);
		return { hasError: true };
	}

	render() {
		if (this.state.hasError && this.props.fallback) {
			// You can render any custom fallback UI
			return this.props.fallback;
		}

		return this.props.children;
	}
}

ErrorBoundary.propTypes = {
	fallback: PropTypes.node,
	children: PropTypes.node,
};

export default ErrorBoundary;
